import {
    NuveiDepositDto,
    MonriDepositDto,
    TransaksDepositDto,
    PixDepositDto,
} from '@core/mappers/transaction/dtos/transactionDtos';
import { TransactionMethod } from '@core/services/antiFraud/types';
import {
    PaymentStatus,
    TransactionType,
} from '@superbet-group/web.types';

type OnlineTransactionDepositDto =
    | NuveiDepositDto
    | MonriDepositDto
    | TransaksDepositDto
    | PixDepositDto;

export type OnlineDeposit = BaseTransaction & {
    kind: TransactionType.Deposit;
    transactionDto: OnlineTransactionDepositDto;
};

export type OnlineWithdrawal = BaseTransaction & {
    kind: TransactionType.Withdrawal;
};

export const PaymentMeans: Record<string, string> = {
    Card: 'cc_card',
    Neteller: 'apmgw_Neteller',
};

export type OnlineTransaction = OnlineWithdrawal | OnlineDeposit;

export const OnlineDepositType = {
    Aircash: 'aircash',
    PaymentIQ: 'paymentiq',
    Nuvei: 'nuvei',
    Pix: 'pix',
    Bancontact: 'bancontact',
};

export type OnlineDepositType = typeof OnlineDepositType[keyof typeof OnlineDepositType];

export type OnlineTransactionProvider =
    | TransactionMethod.PaySafe
    | TransactionMethod.SafeCharge
    | TransactionMethod.Monri
    | TransactionMethod.Bank
    | TransactionMethod.Transaks
    | TransactionMethod.Okto
    | TransactionMethod.Paybrokers;

type BaseTransaction = {
    kind: TransactionType;
    status: PaymentStatus;
    provider: OnlineTransactionProvider;
    method: string;
    id: string;
    amount: string;
    shouldBeReported: boolean;
};
